import { render, staticRenderFns } from "./CompletionIndicator.vue?vue&type=template&id=4c8562f9"
import script from "./CompletionIndicator.vue?vue&type=script&lang=js"
export * from "./CompletionIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports